import React from "react";
import { Mail, Plus } from "lucide-react";

export default function EmptyState({ onAdd }) {
    return (
        <div
            className="text-center py-16 rounded-md border border-dashed border-[#2A3655] bg-[#0A1128]/40"
            data-testid="email-empty-state"
        >
            <Mail className="w-12 h-12 text-[#00A3FF] mx-auto mb-3" />
            <h2 className="text-xl font-bold mb-1">Add your first email account</h2>
            <p className="text-sm text-slate-400 mb-5 max-w-md mx-auto">
                Connect your GoDaddy company email (or Yahoo / iCloud / AOL / Zoho / any custom IMAP+SMTP) to send and read mail without leaving Steeltooth.
            </p>
            <button
                onClick={onAdd}
                data-testid="email-empty-add-btn"
                className="inline-flex items-center gap-2 px-5 py-2.5 rounded-sm bg-[#00A3FF] hover:bg-[#3395FF] text-white font-bold uppercase tracking-wider text-xs"
            >
                <Plus className="w-4 h-4" /> Add email account
            </button>
        </div>
    );
}
